import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import Story from './Story';

class About extends Component {
  render() {
    return(
      <div>
        <Helmet>
          <title>Learn More About BeemaBroker</title>
          <meta name='description' content='Learn more about BeemaBroker.'/>
        </Helmet>
        <Story />
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/js/About/About.js